import React from 'react';
import {
    Card,
    CardBody,
    Row,
    Col,
    Label,
    Input
} from 'reactstrap';

const GetCustomerInfo = ({ 
    customerInfo, 
    selectedContacts, 
    currentInvoice, 
    isEditing, 
    setCurrentInvoice 
}) => {
    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="text-muted text-uppercase fw-semibold mb-0">
                    Müşteri Bilgileri
                </h5>
            </div>

            {customerInfo ? (
                <Card className="border">
                    <CardBody>
                        <Row>
                            {/* Customer details */}
                            <Col md={9}>
                                <Row>
                                    {/* Company Info */}
                                    <Col md={4} className="border-end">
                                        <div className="mb-4">
                                            <h5 className="fw-semibold mb-3">{customerInfo.name}</h5>
                                            <div className="mb-3">
                                                <Label className="text-muted fs-12 mb-1">Şirket Adresi</Label>
                                                <p className="mb-0 fw-medium">{customerInfo.customer_address || '-'}</p>
                                            </div>
                                            <div className="mb-3">
                                                <Label className="text-muted fs-12 mb-1">Vergi No</Label>
                                                <p className="mb-0 fw-medium">{customerInfo.tax_number || '-'}</p>
                                            </div>
                                            <div>
                                                <Label className="text-muted fs-12 mb-1">Vergi Dairesi</Label>
                                                <p className="mb-0 fw-medium">{customerInfo.tax_office || '-'}</p>
                                            </div>
                                        </div>
                                    </Col>

                                    {/* Customer Type */}
                                    <Col md={4} className="border-end">
                                        <div className="mb-3">
                                            <Label className="text-muted fs-12 mb-1">Müşteri Tipi</Label>
                                            <p className="mb-0 fw-medium">{customerInfo.kurumsallik || '-'}</p>
                                        </div>
                                    </Col>

                                    {/* Additional Notes Section */}
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <div className="d-flex align-items-center mb-2">
                                                <Input
                                                    type="checkbox"
                                                    id="showAdditionalNotes"
                                                    className="me-2"
                                                    checked={currentInvoice?.show_customer_additional_notes || false}
                                                    disabled={!isEditing}
                                                    onChange={(e) => {
                                                        if(isEditing) {
                                                            setCurrentInvoice(prev => ({
                                                                ...prev,
                                                                show_customer_additional_notes: e.target.checked
                                                            }));
                                                        }
                                                    }}
                                                />
                                                <Label className="text-muted fs-12 mb-0" for="showAdditionalNotes">
                                                    Ek Not
                                                </Label>
                                            </div>

                                            {currentInvoice?.show_customer_additional_notes && (
                                                <div className="mt-2">
                                                    <Input
                                                        type="textarea"
                                                        className="form-control"
                                                        placeholder="Müşteri veya teklif ile ilgili özel notlar..."
                                                        rows="4"
                                                        value={currentInvoice?.customer_additional_notes || ''}
                                                        disabled={!isEditing}
                                                        onChange={(e) => {
                                                            if(isEditing) {
                                                                setCurrentInvoice(prev => ({
                                                                    ...prev,
                                                                    customer_additional_notes: e.target.value
                                                                }));
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </Col>

                            {/* Selected contacts display */}
                            <Col md={3} className="border-start">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <Label className="text-muted fs-12 mb-0">İlgili Kişiler</Label>
                                </div>

                                <div className="related-contacts">
                                    {selectedContacts.map((contact) => (
                                        <div key={contact.id} className="contact-item border-bottom py-2">
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <h6 className="mb-1 fs-13">{contact.name} {contact.surname}</h6>
                                                    {contact.position && (
                                                        <div className="text-muted small mb-1">{contact.position}</div>
                                                    )}
                                                    {contact.department && (
                                                        <div className="text-muted small mb-1">
                                                            <i className="ri-building-line me-1"></i>
                                                            {contact.department}
                                                        </div>
                                                    )}
                                                    {contact.email && (
                                                        <a href={`mailto:${contact.email}`} className="text-reset d-block small">
                                                            <i className="ri-mail-line me-1"></i>
                                                            {contact.email}
                                                        </a>
                                                    )}
                                                    {contact.phone && (
                                                        <a href={`tel:${contact.phone}`} className="text-reset d-block small">
                                                            <i className="ri-phone-line me-1"></i>
                                                            {contact.phone}
                                                        </a>
                                                    )}
                                                    {contact.cellphone && (
                                                        <a href={`tel:${contact.cellphone}`} className="text-reset d-block small">
                                                            <i className="ri-smartphone-line me-1"></i>
                                                            {contact.cellphone}
                                                        </a>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    {selectedContacts.length === 0 && (
                                        <div className="text-center text-muted small py-3">
                                            İlgili kişi bulunmuyor
                                        </div>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            ) : (
                <div className="bg-light p-3 rounded text-center">
                    <p className="mb-0 text-muted">Müşteri bilgisi bulunamadı</p>
                </div>
            )}
        </div>
    );
};

export default GetCustomerInfo;